import Styled from 'styled-components'

export default Styled.div`
  margin: 0 0 2rem 0;
`



// WEBPACK FOOTER //
// ./src/editor/FormGroup/index.js